import React from 'react'
import { usePathname } from 'lib/i18n/routing'
import type { cmsQuery } from '@web/cms'
import GlobalHeadTags from 'components/GlobalHeadTags'
import Subnav from '@hashicorp/react-components/src/components/subnav'
import { StandardLayoutQueryDocument } from 'types/dato'
import Footer from 'components/materia/footer'
import Nav from 'layouts/standard/nav'
import { useLocale } from 'next-intl'

export default function BlogLayout(props) {
	const pathname = usePathname()
	const locale = useLocale()

	return (
		<>
			<div id="modal-portal" />
			<GlobalHeadTags data={props.data._site} />
			<Nav data={props.data.nav} product={props?.product} />
			<main id="main">
				<Subnav
					locale={locale}
					titleLink={{ text: 'Blog', url: '/blog' }}
					currentPath={pathname}
					menuItems={[
						{
							text: 'Home',
							url: '/blog',
						},
						{
							text: 'Products & Technology',
							url: '/blog/categories/products-technology',
						},
						{
							text: 'Strategy and Insights',
							url: '/blog/categories/strategy-and-insights',
						},
						{
							text: 'Company',
							url: '/blog/categories/company',
						},
						{
							text: 'HashiCorp Voices',
							url: '/blog/categories/hashicorp-voices',
						},
						{
							text: 'All',
							url: '/blog/all',
						},
					]}
				/>
				{props.children}
			</main>
			<Footer {...props.data.footer} locale={locale} />
		</>
	)
}

BlogLayout.cmsQueryParams = [
	{ query: StandardLayoutQueryDocument },
] as Parameters<typeof cmsQuery>
